exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".loading{font-size:200%;z-index:1000000;color:#FFFF;text-align:center;position:absolute;top:35%;left:0;right:0;margin:auto;z-index:2000}", "", {"version":3,"sources":["E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/authentication/login/E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/authentication/login/login.component.css"],"names":[],"mappings":"AAAA,SACI,eAAgB,gBAAkB,YAAc,kBAC7B,kBACA,QACV,OACD,QACC,YACI,YACC,CACjB","file":"login.component.css","sourcesContent":[".loading {\r\n    font-size: 200%; z-index: 1000000; color: #FFFF;\r\n    text-align: center;\r\n    position: absolute;\r\n    top: 35%;\r\n    left: 0;\r\n    right: 0;\r\n    margin: auto;\r\n    z-index: 2000;\r\n}"],"sourceRoot":""}]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Projects/Felixin/Projects/EddyNow/eddy-admin/src/app/pages/authentication/login/login.component.css
// module id = 8VcL
// module chunks = 2